import axios from 'axios';
import { keycloak, login } from '@services/auth/Auth';
import { mergeDeep } from '@utils/mergeDeep';
import { apiSentryError } from '@agilize/components-core';

interface ApiProps {
  fullResponse?: boolean;
  headers?: any;
}

const api = (props?: ApiProps): any => {
  const apiCall = axios.create({
    baseURL: process.env.API,
  });

  apiCall.interceptors.request.use(config => {
    let updatedKeycloak = keycloak;
    if (!keycloak?.token) {
      updatedKeycloak = (window as any).keycloak_dp;
    }
    let updatedConfig = {
      headers: {
        Authorization: `Bearer ${updatedKeycloak.token}`,
        common: {
          'X-Tenant-Id': updatedKeycloak.tokenParsed.tenant[0],
          'X-Company-Id': (window as any).personId,
          'Access-Control-Allow-Origin': '*',
          ...(updatedKeycloak?.tenantToken ? { 'X-Tenant-Token': updatedKeycloak?.tenantToken } : {}),
        },
        Accept: 'application/json',
        ContentType: 'application/json',
        ...(props?.headers ? props?.headers : {}),
      },
    };
    if (config) {
      updatedConfig = mergeDeep(config, updatedConfig);
    }
    return updatedConfig;
  });

  apiCall.interceptors.response.use(
    (response: any) => (props?.fullResponse ? response : response.data),
    async (error: any) => {
      const { response } = error;
      apiSentryError(response);
      if (response && response.status === 401) {
        login();
      }
      return Promise.reject(response);
    },
  );

  return apiCall;
};

export { default as to } from '@utils/awaitTo';
export { default as handleApiError } from '@utils/errorHelper';

export default api;
